import { useQuery } from '@tanstack/react-query';

import { useAppState } from '../../AppStateProvider';

import { signalsApi } from './api';
import { signalsQueryKey } from './signalsQueryKey';

export const useSignalsQuery = (companyDomain: string) => {
  const { isOpen } = useAppState();

  return useQuery({
    queryKey: signalsQueryKey.signals(companyDomain),
    queryFn: async () => {
      return await signalsApi.getSignals(companyDomain);
    },
    enabled: isOpen && !!companyDomain,
  });
};
